import mixpanel from "mixpanel-browser";

let isInitialized = false;

function initMixpanel(token: string): void {
  if (isInitialized) return;
  if (typeof window === "undefined") return;
  mixpanel.init(token);
  isInitialized = true;
}

function isMixpanelInitialized(): boolean {
  return isInitialized;
}

/**
 * Safe track for non-React code paths. No-ops until Mixpanel has been
 * initialized (which only happens with GDPR performance consent) and never
 * throws, so telemetry can't break recovery flows like chunk reloads.
 */
function trackEvent(...args: Parameters<typeof mixpanel.track>): void {
  if (!isInitialized) return;
  try {
    mixpanel.track(...args);
  } catch {
    // Swallow — tracking must never take down the caller.
  }
}

export { initMixpanel, isMixpanelInitialized, trackEvent };
